import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import { getTouchbackYardline } from "../utils/context-utils";

export default class FairCatch extends Fragment {
    constructor(fairCatchBy) {
        super();

        this.code = "FC";
        this.fairCatchBy = fairCatchBy;

        this.requiredData = [
            {
                name: "fairCatchBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => true,
                displayName: "Fair Catch By",
                title: (team) => `Fair Catch By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player
                     from ${team.teamName} or enter the roster number`,
                isEditable: true
            }
        ];
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }

    getFragmentTeamId() {
        return this.fairCatchBy?.teamId;
    }

    getPlayers() {
        return [this.fairCatchBy];
    }

    summarize(summaryContext, stringifier, play) {
        const {
            homeTeamHasPossession,
            fieldPosition,
            isKickOffPlay,
            gameConfig
        } = summaryContext;
        const { general } = gameConfig;
        const { autoFairCatchTb, fieldLength } = general;
        const tbSpot = getTouchbackYardline(
            isKickOffPlay,
            homeTeamHasPossession,
            gameConfig
        );

        const isTouchback =
            autoFairCatchTb &&
            isKickOffPlay &&
            (homeTeamHasPossession
                ? fieldPosition < tbSpot
                : fieldPosition > tbSpot);

        const formattedSpot = stringifier.niceFieldPosition(
            fieldLength,
            fieldPosition,
            summaryContext.homeTeam?.abbrName,
            summaryContext.awayTeam?.abbrName
        );

        const formattedTbSpot = stringifier.niceFieldPosition(
            fieldLength,
            tbSpot,
            summaryContext.homeTeam?.abbrName,
            summaryContext.awayTeam?.abbrName
        );

        const message = `fair catch by ${stringifier.firstInitial(
            this.fairCatchBy
        )}
		at the ${formattedSpot}${
            isTouchback ? `, ball placed at ${formattedTbSpot}` : ""
        }`;

        return new FragmentSummary(message);
    }

    toJSON() {
        return {
            ...super.toJSON(),
            fairCatchBy: playerReducer(this.fairCatchBy)
        };
    }
}
